"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../..");
var context_1 = require("../../../../context");
var enums_1 = require("../../../../types/enums");
var utils_1 = require("../../../../utils");
var Card_1 = require("../../../Card");
var FormControl_1 = __importDefault(require("../../../FormControl"));
var Select_1 = __importDefault(require("../../../Select"));
var Tabs_1 = require("../../../Tabs/Tabs");
exports.errorKeys = [
    'main_system',
    'main_system_no',
    'cylinder_present',
    'cylinder_insulation',
    'num_bedrooms',
    'energy_issues',
    'energy_issues_other',
    'main_system_other',
];
var HotWaterForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c;
    var _d = context_1.useSemantics(), trans = _d.trans, options = _d.options;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var _e = formik_1.useFormikContext(), errors = _e.errors, values = _e.values;
    var _f = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.hot_water) || {}), formErrors = _f[0], setFormErrors = _f[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.hot_water) || {}); }, [(_c = errors.project) === null || _c === void 0 ? void 0 : _c.hot_water]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('project:slhh::headings.hot-water'), subHeading: trans('project:slhh::headings.details') },
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.main_system, label: trans('project:slhh::labels.main-system'), showOther: values.project.hot_water.main_system === enums_1.BooleanOption.NO, other: react_1.default.createElement(FormControl_1.default, { errors: formErrors.main_system_no, label: trans('project:slhh::labels.main-system-no') },
                react_1.default.createElement(__1.TextArea, { fast: true, name: "project.hot_water.main_system_no", maxLength: 5000 })) },
            react_1.default.createElement(Select_1.default, { width: "xs", options: options.boolean(), name: "project.hot_water.main_system" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.cylinder_present, label: trans('project:slhh::labels.cylinder-present') },
            react_1.default.createElement(Select_1.default, { width: "xs", options: options.boolean(), name: "project.hot_water.cylinder_present" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.cylinder_insulation, label: trans('project:slhh::labels.cylinder-insulation') },
            react_1.default.createElement(Select_1.default, { width: "xs", options: {
                    jacket: 'Jacket',
                    foam: 'Foam',
                    none: 'None',
                }, name: "project.hot_water.cylinder_insulation" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.num_bedrooms, label: trans('project:slhh::labels.num-bedrooms') },
            react_1.default.createElement(Select_1.default, { width: "xs", options: {
                    '1': '1',
                    '2': '2',
                    '3': '3',
                    '4': '4',
                    '5': '5',
                    '6': '6',
                    '7': '7',
                    '8': '8',
                }, name: "project.hot_water.num_bedrooms" })),
        react_1.default.createElement(FormControl_1.default, { errors: formErrors.energy_issues, label: trans('project:slhh::labels.energy-issues'), flush: true, showOther: values.project.hot_water.energy_issues === enums_1.BooleanOther.OTHER, other: react_1.default.createElement(FormControl_1.default, { errors: formErrors.energy_issues_other, label: trans('project:slhh::labels.energy-issues-other') },
                react_1.default.createElement(__1.TextArea, { fast: true, name: "project.hot_water.energy_issues_other", maxLength: 5000 })) },
            react_1.default.createElement(Select_1.default, { width: "xs", options: {
                    old_or_inefficient: trans('project:slhh::enum.energy-issue.old_or_inefficient'),
                    broken_boiler: trans('project:slhh::enum.energy-issue.broken_boiler'),
                    no_gas_central: trans('project:slhh::enum.energy-issue.no_gas_central'),
                    storage_heater_upgrade: trans('project:slhh::enum.energy-issue.storage_heater_upgrade'),
                    poorly_insulated_loft: trans('project:slhh::enum.energy-issue.poorly_insulated_loft'),
                    no_wall_cavity_insulation: trans('project:slhh::enum.energy-issue.no_wall_cavity_insulation'),
                    no_floor_insulation: trans('project:slhh::enum.energy-issue.no_floor_insulation'),
                    no_solid_floor_insulation: trans('project:slhh::enum.energy-issue.no_solid_floor_insulation'),
                    mould_damp: trans('project:slhh::enum.energy-issue.mould_damp'),
                    none: trans('project:slhh::enum.energy-issue.none'),
                    other: trans('project:slhh::enum.energy-issue.other'),
                }, name: "project.hot_water.energy_issues" }))));
};
exports.default = HotWaterForm;
//# sourceMappingURL=HotWaterForm.js.map